import { useEffect, useState } from "react";
import { useIsFetching, useQueryClient } from "@tanstack/react-query";
import { AlertCircle, X } from "lucide-react";

/**
 * Detects sustained backend instability by watching React Query's global error
 * state. Shows a dismissible banner when 2+ queries have errored recently,
 * indicating a likely provider incident (DNS, 5xx, timeouts).
 */
const StatusBanner = () => {
  const qc = useQueryClient();
  const isFetching = useIsFetching();
  const [degraded, setDegraded] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const cache = qc.getQueryCache();
    const evaluate = () => {
      const erroredQueries = cache.getAll().filter((q) => q.state.status === "error");
      setDegraded(erroredQueries.length >= 2);
    };
    evaluate();
    const unsubscribe = cache.subscribe(evaluate);
    return () => unsubscribe();
  }, [qc, isFetching]);

  if (!degraded || dismissed) return null;

  return (
    <div className="sticky top-0 z-50 w-full bg-destructive/10 border-b border-destructive/30 backdrop-blur-md">
      <div className="container mx-auto flex items-center gap-3 px-4 py-2.5 text-sm">
        <AlertCircle size={16} className="text-destructive shrink-0" />
        <p className="flex-1 text-foreground">
          <strong className="font-semibold">Instabilidade temporária:</strong> alguns conteúdos podem demorar para
          carregar. Estamos tentando reconectar automaticamente.
        </p>
        <button
          onClick={() => setDismissed(true)}
          className="text-muted-foreground hover:text-foreground transition-colors"
          aria-label="Fechar aviso"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
};

export default StatusBanner;
